// URL of the marketing lander / checkout funnel. Used for cross-repo re-subscribe
// deep-links (canceled users -> `${LANDER_URL}/checkout?email=...`). Set via
// `VITE_LANDER_URL` at build time. Falls back to prod so a missing env in
// dev/staging doesn't silently produce a broken `undefined/checkout?email=...`
// URL; set the env explicitly to override.
export const LANDER_URL: string =
  (import.meta.env.VITE_LANDER_URL as string | undefined) || 'https://unbreakableapp.com'

/**
 * Build a re-subscribe URL that lands cancelled users directly on the lander's
 * /checkout plan-select page with their email prefilled, skipping the quiz
 * funnel they already completed.
 */
export function buildResubscribeUrl(email: string | null | undefined): string {
  const base = LANDER_URL.replace(/\/$/, '')
  if (!email) return `${base}/checkout`
  return `${base}/checkout?email=${encodeURIComponent(email)}`
}
